<template>
  <div
      v-if="!paymentProvider.showGrouped"
      class="payment-provider-item"
      @click="handleClick"
  >
    <span class="payment-provider-item-logo">
      <img
          :src="paymentProvider.logo"
          :alt="paymentProvider.displayName"
          :class="{ 'disabled-logo': !paymentProvider.enabled }"
      />
    </span>
    <span class="payment-provider-item-container">
      <span class="payment-provider-item-text">
        {{ $t(paymentProvider.displayName) }}
      </span>
      <span class="payment-provider-item-tooltip">
        <img
            v-if="paymentProvider.toolTip === 'Rápido'"
            src="@/assets/icons/bolt.svg"
            alt="Rápido"
            style="margin-right: 5px; margin-top: auto; margin-bottom: auto"
        />
      </span>
      {{ paymentProvider.toolTip }}
    </span>
  </div>
  <span
    v-else
    :id="paymentProvider.displayName.replace(/[\s']/g, '-').toLowerCase()"
    class="payment-provider-item-grouped"
    @click="handleClick"
  >
    <img
      :src="paymentProvider.logo"
      :alt="paymentProvider.displayName"
      :class="{ 'disabled-logo': !paymentProvider.enabled }"
    >
  </span>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {IPaymentProvider} from "@/types/IPaymentProvider";
import {useI18n} from "vue-i18n";

export default defineComponent({
  name: "PaymentProviderItem",
  props: {
    paymentProvider: {
      type: Object as () => IPaymentProvider,
      required: true,
    },
  },
  emits: ["select-payment-provider"],
  methods: {
    handleClick() {
      if (!this.paymentProvider.enabled) {
        return;
      }
      this.$emit("select-payment-provider", this.paymentProvider.name);
    },
  },
  setup(props, {emit}) {
    const {t, locale} = useI18n();
    return {t};
  },
});
</script>

<style scoped>
.payment-provider-item {
  display: flex;
  padding: 16px;
  margin-top: 15px;
  align-items: center;
  border-radius: 10px;
  border: 1px solid var(--Gray-elements-Border-1-inactive-botton);
  background: var(--main-white);
}

.payment-provider-item:hover {
  background: #f0f0f0;
}

.payment-provider-item-logo {
  text-align: left;
  color: var(--Typography-Text-1);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  align-items: center;
  display: flex;
}

.payment-provider-item-logo img {
  max-width: 35px;
  margin: auto;
}

.payment-provider-item-container {
  display: flex;
  flex: 1 0 0;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
}

.payment-provider-item-text {
  flex: 1 0 0;
  text-align: left;
  color: var(--Typography-Text-1);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  margin-left: 10px;
}

.payment-provider-item-tooltip {
  color: var(--Typography-Text-2);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;
  /* Text lighter */
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

.payment-provider-item-grouped {
  background: #fff;
}

.payment-provider-item-grouped:hover {
  background: #f0f0f0;
}

.disabled-logo {
  filter: grayscale(100%);
}
</style>
